import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
// import Button from "../../common/Button";

const ConveyorSelectionForm = ({ onSelect, onCancel, conveyors }) => {
    if (!conveyors) {
        return;
    }

    return (
        <ConveyorSelectionFormBlock>
            <table>
                <thead>
                    <tr>
                        <td>Conveyor ID</td>
                        <td>
                            Capacity
                            <br />
                            (tph)
                        </td>
                        <td>H.L(m)</td>
                        <td>V.L(m)</td>
                        <td>Material</td>
                        <td>
                            Density
                            <br />
                            (kg/m3)
                        </td>
                        <td>BW(mm)</td>
                        <td>Speed(m/s)</td>
                    </tr>
                </thead>
                <tbody>
                    {conveyors.map((conveyor) => {
                        const {
                            title,
                            body: { input },
                        } = conveyor;
                        return (
                            <tr onClick={() => onSelect(conveyor)}>
                                <td>{title}</td>
                                <td>{input?.capacity}</td>
                                <td>{input?.length}</td>
                                <td>{input?.height}</td>
                                <td>{input?.materialConveyed}</td>
                                <td>{input?.specificGravity}</td>
                                <td>{input?.beltWidth}</td>
                                <td>{input?.beltSpeed}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {/* <div className="btn-area">
                <Button onClick={onCancel}>Cancel</Button>
            </div> */}
        </ConveyorSelectionFormBlock>
    );
};

export default ConveyorSelectionForm;

const ConveyorSelectionFormBlock = styled.div`
    table {
        border-collapse: collapse;
        text-align: center;
        td {
            padding: 0.5rem 0.5rem;
        }
    }

    thead tr td {
        border-bottom: 1px solid ${palette.gray[6]};
    }

    tr {
        &:hover {
            background-color: ${palette.gray[1]};
            transition: 0.3s;
            cursor: pointer;
        }
    }

    .btn-area {
        margin-top: 1rem;
        display: flex;
        justify-content: flex-end;
    }
`;
